module.exports = __webpack_public_path__ + "static/media/403.41acc6f2.svg";